import PropTypes from "prop-types";
import React, { useState } from "react";
import { Grid, MenuItem } from "@material-ui/core";
import FilledSelect from "./FilledSelect";
import FilledTextField from "./FilledTextField";

export const RangeInput = ({
  label,
  filledSelectProps,
  filledTextProps,
  onChangeFloor,
  onChangeCeiling,
  floor,
  ceiling,
}) => {
  const [comparisonOperator, setComparisonOperator] = useState("between");

  const handleFloorChange = ({ target: { value } }) => onChangeFloor(value.trim());
  const handleCeilChange = ({ target: { value } }) => onChangeCeiling(value.trim());
  const onChangeSelect = ({ target: { value } }) => {
    if (value === "greater_than") onChangeCeiling(undefined);
    else if (value === "less_than") onChangeFloor(undefined);

    setComparisonOperator(value);
  };

  return (
    <>
      <Grid item xs={12} md={3}>
        <FilledSelect
          {...filledSelectProps}
          value={comparisonOperator}
          label={label}
          FormControlProps={{ fullWidth: true, margin: "normal" }}
          onChange={onChangeSelect}
        >
          <MenuItem value="greater_than">Greater than</MenuItem>
          <MenuItem value="less_than">Less than</MenuItem>
          <MenuItem value="between">Between</MenuItem>
        </FilledSelect>
      </Grid>
      <Grid item xs={12} md={3}>
        <FilledTextField
          value={floor}
          label={`${label} ≥`}
          disabled={comparisonOperator === "less_than"}
          onChange={handleFloorChange}
          {...filledTextProps}
          mask={floor ? filledTextProps.mask : null}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FilledTextField
          value={ceiling}
          label={`${label} ≤`}
          disabled={comparisonOperator === "greater_than"}
          onChange={handleCeilChange}
          {...filledTextProps}
          mask={ceiling ? filledTextProps.mask : null}
        />
      </Grid>
    </>
  );
};

RangeInput.propTypes = {
  filledSelectProps: PropTypes.object,
  filledTextProps: PropTypes.object,
  label: PropTypes.string,
  onChangeFloor: PropTypes.func.isRequired,
  onChangeCeiling: PropTypes.func.isRequired,
  floor: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ceiling: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

RangeInput.defaultProps = {
  filledSelectProps: {},
  filledTextProps: {},
  label: "",
  floor: undefined,
  ceiling: undefined,
};

export default RangeInput;
